import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute } from 'react-router';
import configureStore from './store/configureStore';
import { PAGES, config } from './config';
import { appActions, userActions, facebookActions } from './actions';
import MobileDetect from 'mobile-detect';
import history from './router/history';
import { passPropsTo, initErrorLogger } from './utils';
import { EmailPageWithRouter as EmailPage } from './containers/pages/EmailPage';
import { RegisterPageWithRouter as RegisterPage } from './containers/pages/RegisterPage';
import { PasswordPageWithRouter as PasswordPage } from './containers/pages/PasswordPage';
import App from './containers/App';

export default class Root extends Component {
	static propTypes = {
		locale: PropTypes.string,
		facebookLoginStatus: PropTypes.object,
		isAppEmbedded: PropTypes.bool,
		children: PropTypes.element,
		publicPath: PropTypes.string,
		initErrorLogger: PropTypes.func.isRequired,
	};
	static defaultProps = {
		isAppEmbedded: true,
		initErrorLogger,
	};
	constructor(props) {
		super(props);
		this.store = configureStore();
	}
	componentWillMount() {
		this.setLocale();
		this.initErrorLogger();
		this.setFacebookLoginStatus();
	}
	componentDidMount() {
		this.setDeviceType();
	}
	setFacebookLoginStatus() {
		const { facebookLoginStatus } = this.props;
		this.store.dispatch(facebookActions.updateFacebookLoginStatus(facebookLoginStatus));
	}
	setLocale() {
		const { locale } = this.props;
		this.store.dispatch(appActions.updateLocale(locale ? locale : config.defaultLocale));
	}
	setDeviceType() {
		const deviceDetected = new MobileDetect(window.navigator.userAgent);
		const deviceType = deviceDetected.mobile() ? 'Mobile' : 'Desktop';
		this.store.dispatch(appActions.updateDeviceType(deviceType));
	}
	initErrorLogger() {
		const { initErrorLogger } = this.props;
		const { version, name } = config.app;
		const hasInit = false;
		initErrorLogger(version, name, hasInit);
	}
	render() {
		const {
			children,
			isAppEmbedded,
			publicPath,
		} = this.props;

		const EmailPageWithProps = passPropsTo(EmailPage, {...this.props});
		const PasswordPageWithProps = passPropsTo(PasswordPage, {...this.props});
		const RegisterPageWithProps = passPropsTo(RegisterPage, {...this.props});
		const AppWithProps = passPropsTo(App, {...this.props});

		return (
			<Provider store={this.store}>
				{ isAppEmbedded ?
					<div>{ children }</div>
					:
					<Router history={history}>
						<Route
							path={publicPath || '/'}
							component={ AppWithProps }>
							<IndexRoute components={ EmailPageWithProps } />
							<Route
								path={ PAGES.EmailPage.route }
								components={ EmailPageWithProps } />
							<Route
								path={ PAGES.PasswordPage.route }
								components={ PasswordPageWithProps } />
							<Route
								path={ PAGES.RegisterPage.route }
								components={ RegisterPageWithProps } />
							<Route
								path='*'
								components={ EmailPageWithProps } />
						</Route>
					</Router>
				}
			</Provider>
		);
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/index.js